import Naluri from '~/common/api/naluri'
import {
  MODULES_GET_MODULE_PLAYLIST,
  MODULES_GET_MODULE_PLAYLIST_ERROR,
} from './constants';

export function getPlaylists(userId) {
  return (dispatch, getState) => {
    Naluri.get(`/api/expert/playlists/${userId}`)
      .then(response => {
        // filtering out all the legacy modules as now, coaches will only see lessons from clear xp
        // the Assessments category is surfacing the remaining native modules such as DASS, Physical Assessment, Self Resilience
        const assessmentCategories = response.filter(categories => categories.title === 'Assessments')
        dispatch({
          type: MODULES_GET_MODULE_PLAYLIST,
          data: assessmentCategories
        })
      })
      .catch(err => {
        dispatch({
          type: MODULES_GET_MODULE_PLAYLIST_ERROR,
          data: { error: err }
        });
      });
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case MODULES_GET_MODULE_PLAYLIST:
      return {
        ...state,
        playlists: action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/getPlaylists.js